import { create } from 'zustand';
import { KM } from './km';

export type Locale = 'km' | 'en';
const KEY = 'lp-locale';

function initial(): Locale {
  try {
    return window.localStorage.getItem(KEY) === 'en' ? 'en' : 'km';
  } catch {
    return 'km';
  }
}

export const useLocale = create<{ locale: Locale; set: (l: Locale) => void }>((set) => ({
  locale: initial(),
  set: (locale) => {
    try {
      window.localStorage.setItem(KEY, locale);
    } catch {
      /* private window: the choice lasts for this page only */
    }
    document.documentElement.lang = locale;
    set({ locale });
  },
}));

/** the text in the chosen language — English is the key; a missing Khmer text shows the English one */
export function t(en: string): string {
  return useLocale.getState().locale === 'km' ? (KM[en] ?? en) : en;
}

/** re-render when the language changes, and return t */
export function useT(): typeof t {
  useLocale((s) => s.locale);
  return t;
}
